/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/jump': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 4C9.371 4 4 9.372 4 16s5.371 12 12 12 12-5.372 12-12S22.629 4 16 4zm-6 13H6v-1h4v1zm2-1h4v1h-4v-1zm12.243 4.036l-.707.707-3.535-3.536-3.537 3.536-.707-.707 3.537-3.536-3.535-3.535.707-.707 3.535 3.536 3.535-3.535.707.707-3.535 3.534 3.535 3.536z"/><path pid="1" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14c7.721 0 14-6.28 14-14S23.721 2 16 2z"/>'
  }
})
